export const SHOW_CONFIG: string[] = [
  'createUnit',
  'featureOvertimeMethods',
  'featureShowMyPayslips',
  'featureShowMySaly',
  'defaultShiftType',
  'passwordSecurityLevel',
  'featureSalaryOnTask',
  'featureWebCalSetByCustomer',
  'featureWebCalSetByQuinyx',
  'showWebCamOnWP3',
  'featureExternalSetByQuinyx',
  'featureExternalSetByCustomer',
];
